import script from "./AboutTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutTopComponent.vue?vue&type=style&index=0&id=9b41cf78&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b41cf78"]])

export default __exports__